// pages/ForgotPassword/styles.js
import styled from "styled-components";
import { motion } from "framer-motion";
import {
	LoginWrapper,
	LoginCard,
	Form,
	FormGroup,
	Label,
	Input,
	ErrorMessage,
} from "../Login/styles";

export const ForgotPasswordWrapper = styled(LoginWrapper)``;

export const ForgotPasswordCard = styled(LoginCard)`
	max-width: 400px;
	text-align: center;

	h1 {
		font-size: ${(props) => props.theme.typography.sizes["2xl"]};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.sm};
	}

	> p {
		color: ${(props) => props.theme.colors.text.secondary};
		margin-bottom: ${(props) => props.theme.spacing.xl};
	}
`;

export const SuccessMessage = styled.div`
	padding: ${(props) => props.theme.spacing.xl};
	background: ${(props) => props.theme.colors.success.main}15;
	border-radius: ${(props) => props.theme.borderRadius.lg};
	margin-bottom: ${(props) => props.theme.spacing.xl};

	h3 {
		color: ${(props) => props.theme.colors.success.main};
		margin-bottom: ${(props) => props.theme.spacing.sm};
	}

	p {
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;

export const BackToLogin = styled.div`
	margin-top: ${(props) => props.theme.spacing.xl};
	font-size: ${(props) => props.theme.typography.sizes.sm};

	a {
		color: ${(props) => props.theme.colors.primary.main};
		text-decoration: none;
		font-weight: ${(props) => props.theme.typography.weights.medium};

		&:hover {
			text-decoration: underline;
		}
	}
`;

export { Form, FormGroup, Label, Input, ErrorMessage };
